import React from 'react'
import { AdminCatalogueView as View } from './Catalogue';
import { ButtonShadcn } from '@/components/ui/button-shadcn';
import { ArrowLeftIcon, XIcon } from 'lucide-react';

interface IAdminModalHeader {
  view: View;
  title: string;
  showBackButton: boolean;
  onBack: () => void;
  onClose: () => void;
}

const AdminModalHeader = ({ view, title, showBackButton, onBack, onClose }: IAdminModalHeader) => {
  return (
    <div className="flex items-center justify-between px-4 py-3 border-b bg-muted/30">
      <div className="flex items-center gap-3">
        {showBackButton && (
          <ButtonShadcn
            variant="ghost"
            size="icon"
            onClick={onBack}
            className="h-8 w-8"
          >
            <ArrowLeftIcon className="h-4 w-4" />
          </ButtonShadcn>
        )}
        <h2 className="text-lg font-semibold">{title}</h2>
      </div>
      <ButtonShadcn
        variant="ghost"
        size="icon"
        onClick={onClose}
        className="h-8 w-8 opacity-70 hover:opacity-100"
      >
        <XIcon className="h-4 w-4" />
        <span className="sr-only">Close</span>
      </ButtonShadcn>
    </div>
  )
}

export default AdminModalHeader